import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../slices/userSlice";
import { Modal, Tooltip } from "flowbite-react";
import { useNavigate } from "react-router";
import { resetFilters } from "../slices/seo/tasksFiltersSlice";

function Header() {
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {}, [user]);

  return (
    <>
      <nav className="flex justify-between items-center w-full h-[75px] z-10 px-2.5 sm:px-7 py-4 shadow-lg fixed top-0 left-0">
        {/* left section */}
        <div
          className="flex gap-2 sm:gap-4 items-center cursor-pointer"
          onClick={() => (user ? navigate("/collections") : {})}
        >
          <img
            className="h-full w-[2.5rem] object-cover"
            src="/Images/Logo_1.jpg"
            alt=""
          />
          <h3 className="text-sm sm:text-base whitespace-nowrap">
            Physics Wallah
          </h3>
        </div>

        {Object.keys(user).length !== 0 && (
          <div className="flex gap-3 pr-3 sm:pr-5 sm:pt-3">
            <div className="flex items-center gap-1.5 sm:gap-3 font-normal">
              <span className="text-xs sm:text-sm whitespace-nowrap">
                {user.name}
              </span>
              <Tooltip
                content={`Profile`}
                style="dark"
                placement="top"
                arrow={false}
              >
                <i
                  onClick={() => navigate("/profile")}
                  className="sm:w-10 sm:h-10 w-7 h-7 fa-solid fa-user text-xs sm:text-base flex justify-center cursor-pointer items-center rounded-full bg-[#e6e6e6] px-2 py-2 sm:px-3.5 sm:py-3"
                ></i>
              </Tooltip>
            </div>
            <Tooltip
              content={`Logout`}
              style="dark"
              placement="top"
              arrow={false}
            >
              <div className="flex sm:w-10 sm:h-10 w-7 h-7 justify-center cursor-pointer items-center rounded-full bg-[#e6e6e6] px-3.5 py-3">
                <i
                  className="fa-solid fa-right-from-bracket text-xs sm:text-base"
                  onClick={() => setShowLogoutModal(true)}
                ></i>
              </div>
            </Tooltip>
          </div>
        )}

        {/* right section */}
      </nav>

      <Modal
        show={showLogoutModal}
        size="sm"
        popup={true}
        onClose={() => setShowLogoutModal(false)}
      >
        <Modal.Header />
        <Modal.Body>
          <div className="text-center">
            <i className="fa-solid text-6xl fa-circle-exclamation mx-auto mb-4 h-14 w-14 text-[#414bb2]" />
            <h3 className="mb-5 text-base font-normal text-gray-500 dark:text-gray-400">
              Do you really want to logout?
            </h3>
            <div className="flex justify-center gap-5 items-center">
              <button
                onClick={() => {
                  setShowLogoutModal(false);
                  dispatch(resetFilters());
                  dispatch(logout());
                }}
                className="bg-[#414bb2] text-white text-sm px-2.5 py-1.5 rounded"
              >
                Yes, I'm sure
              </button>
              <button
                onClick={() => setShowLogoutModal(false)}
                className="bg-gray-600 text-white text-sm px-2.5 py-1.5 rounded"
              >
                No, cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Header;
